import React from "react";
import RenderResourcesVideos from "./RenderResoursesVideos";

const brokerVideos = [
  {
    name: "Accessing the Portal",
    link: "https://www.loom.com/embed/4549e179f8dc4ec6aa3f26d10871ca0a?sid=f8b3f3f2-cc43-4415-bcf6-d8d83abcce0b",
  },
  {
    name: "Dashboard Overview",
    link: "https://www.loom.com/embed/9a88b459b16548b493e14f3c7d6e4daa",
  },
  {
    name: "Adding an Employer Group",
    link: "https://www.loom.com/embed/04104ca7621146bfa7c8ab23a1806a50",
  },
  {
    name: "How to add and manage individuals",
    link: "https://www.loom.com/embed/3a78c3f3fa024d6ab6f5829db02f465f",
  },
  {
    name: "Enrollment Process for Clients",
    link: "https://www.loom.com/embed/21cbc5c723d649c690cca9a3905dac6c",
  },
];

const BrokersResources = () => {
  return <RenderResourcesVideos resourcesVideos={brokerVideos} />;
};

export default BrokersResources;
